import React from 'react';
import { connect } from 'react-redux';
import Header from '../Header';
import {
  page,
  page__open,
  page__title,
  page__body,
  page__open__inner
} from './Page.module.scss';
import { toggleDrawer as toggleDrawerAction } from '../../state/app';

const Page = ({ title, logo, children, isDrawerOpen, toggleDrawer }) => (
  <div className={`${page} ${isDrawerOpen ? page__open : null}`}>
    <Header logo={logo}/>
    <div className={isDrawerOpen ? page__open__inner : null} onClick={() => toggleDrawer(false)}>
      { title && <h1 className={page__title}>{title}</h1>}
      <div className={page__body}>
        {children}
      </div>
    </div>
  </div>
);

export default connect(
  (state) => ({ isDrawerOpen: state.app.isDrawerOpen }),
  (dispatch) => ({ toggleDrawer: (open) => dispatch(toggleDrawerAction(open)) }),
)(Page);
